import { z } from 'zod';
import { idValidator } from '@/schemas/common/validators';

// Request schema for bulk archive
export const BulkArchiveRequestSchema = z.object({
  listingIds: z.array(idValidator).min(1, 'At least one listing ID is required'),
});

export type BulkArchiveRequest = z.infer<typeof BulkArchiveRequestSchema>;

// Response schema for bulk archive
export const BulkArchiveResponseSchema = z.discriminatedUnion('success', [
  z.object({
    success: z.literal(true),
    archivedCount: z.number(),
    totalRequested: z.number(),
  }),
  z.object({
    success: z.literal(false),
    error: z.string(),
    found: z.number().optional(),
    requested: z.number().optional(),
    details: z.string().optional(),
  }),
]);

export type BulkArchiveResponse = z.infer<typeof BulkArchiveResponseSchema>;
